import { defineStyle, defineStyleConfig } from '@chakra-ui/react';

export const fontTheme = {
    heading: 'Circular, sans-serif',
    body: 'Roboto, sans-serif',
};

export const fontSizesTheme = {
    xxl: '1.35rem',
};

export const headingTheme = defineStyleConfig({
    baseStyle: {
        color: 'charcoal.900',
    },
    sizes: {
        xmd: defineStyle({
            fontSize: ['xxl', null, 'x-large'],
            lineHeight: 1,
        }),
    },
    variants: {
        bold: {
            fontFamily: 'Roboto, sans-serif',
            fontWeight: '700',
        },
        regular: {
            fontFamily: 'Roboto, sans-serif',
            fontWeight: '400',
        },
        thin: {
            fontFamily: 'Roboto, sans-serif',
            fontWeight: '200',
        },
        circular: {
            fontFamily: 'Circular, sans-serif',
            fontWeight: '700',
            letterSpacing: '-0.03em',
        },
    },
    defaultProps: {
        variant: 'circular',
    },
});
